import { render, staticRenderFns } from "./DialogRemoveUser.vue?vue&type=template&id=553e3c50"
import script from "./DialogRemoveUser.vue?vue&type=script&lang=js"
export * from "./DialogRemoveUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports